import styled from '@emotion/styled';

export const CardContent = styled.div<{ small?: boolean; border?: boolean; noPadding?: boolean }>`
    padding: ${({ theme, small, noPadding }) => noPadding
        ? 0
        : small ? 6 : theme.card.padding}px;
    border-bottom: 0px solid ${({ theme }) => theme.colors.border};
    border-bottom-width: ${({ border }) => border ? 1 : 0}px;
`;
